// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { View, LogBox } from "react-native";
import React from "react";
import BottomNavigation from "./components/Navigator/AppNavigator";
import { StatusBar } from "expo-status-bar";

LogBox.ignoreLogs([
    'Failed prop type: Invalid prop `textStyle` of type `array` supplied to `Cell`, expected `object`.',
    'Microsoft Edge is moving towards a new experience that allows users to choose to browse without third-party cookies.',
    'A listener indicated an asynchronous response by returning true, but the message channel closed before a response was received',
    'is no longer supported in React 18. Use createRoot instead. Until you switch to the new API, your app will behave as if',
    'consider purchasing a commercial license from'
]);

const App = () => {
    return (
        <View style={{ flex: 1 }}>
            <StatusBar style="auto" />
            <BottomNavigation />
        </View>
    );
};

export default App;